// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';
import classNames from 'classnames/bind';

import phoneImage from '../../images/phone_cropped.png';
import phoneLongImage from '../../images/phone_long.png';
import mobileHeaderIndex from '../../images/mobile-new.png';
import mobileHeaderIndexReal from '../../images/blueShape-mobile.png';
import mobileHeader from '../../images/right-top-mobile.png';
import desktopHeaderRight from '../../images/right-top-background.png';
import desktopFooter from '../../images/left-bottom-background.png';
import desktopHeaderLeft from '../../images/left-top-background.png';

import zigzagLines from '../../images/zigzag-lines.png';
import rectangle1 from '../../images/rectangle-2.png';
import rectangle2 from '../../images/rectangle2-1.png';
import rectangle2Mobile from '../../images/rectangle-mobile.png';
import blueRectangle from '../../images/blue-rectangle.png';
import pinkRectangle from '../../images/pink-rectangle.png';
import rectanglePackGuide from '../../images/rectangle-pg.png';
import rectangleHiw from '../../images/rectangle-hiw.png';

import { Header, Footer } from '../../components';
import { headerLinks, footerLinks } from '../../config/navigationConstants';
import styles from './styles';
import '../main.css';

const Navigation = ({
  children,
  classes,
  footer,
  isIndex,
  mobileLikeIndex,
  isPG,
  isHiw,
  haveBlueRect,
}) => {

  const mobileTopLikeIndex = (
    <div className={classes.mobileImageContainer}>
      <img className={classes.image} src={mobileHeaderIndex} alt={'background'} />
    </div>
  );

  const mobileTopLikeIndexReal = (
    <div className={classes.mobileImageContainer}>
      <img className={classes.image} src={mobileHeaderIndexReal} alt={'background'} />
    </div>
  );

  const mobileTopNotIndex = (
    <div className={classes.mobileRightTopBackground}>
      <img className={classes.image} src={mobileHeader} alt={'background'} />
    </div>
  );

  const bottomNotIndex = (
    <div className={classes.leftBottomBackground}>
      <img className={classes.image} src={desktopFooter} alt={'background'} />
    </div>
  );

  const desktopTopIndexZigzagLines = (
    <div className={classes.zigzagLines}>
      <img className={classes.image} src={zigzagLines} alt={'background'} />
    </div>
  );

  const desktopTopNotIndex = (
    <div className={classes.rightTopBackground}>
      <img className={classes.image} src={desktopHeaderRight} alt={'background'} />
    </div>
  );

  const desktopLeftBubble = (
    <div className={classes.leftTopBackground}>
      <img className={classes.image} src={desktopHeaderLeft} alt={'background'} />
    </div>
  );

  const rectangleOne = (
    <img
      src={rectangle1}
      alt={'rectangle1'}
      className={classNames(classes.rectangle1, (mobileLikeIndex || isIndex)
        ? classes.topLikeIndexRectangle1 : classes.topNotLikeIndexRectangle1)}
    />
  );

  const rectangleTwo = (
    <img
      src={rectangle2}
      alt={'rectangle2'}
      className={classes.rectangle2}
    />
  );

  const rectangleTwoMobile = (
    <img src={rectangle2Mobile} alt={'rectangle2'} className={classes.rectangle2IsIndex} />
  );

  const blueRectangleContainer = (
    <img src={blueRectangle} alt={'blue-rectangle'} className={classes.blueRectangle} />
  );

  const pinkRectangleContainer = (
    <img
      src={pinkRectangle}
      alt={'pink-rectangle'}
      className={classNames(classes.pinkRectangle, isIndex ? classes.pinkRectangleIsIndex
        : classes.pinkRectangleIsNotIndex)}
    />
  );

  const blueRectangleLeft1 = (
    <img
      src={blueRectangle}
      alt={'blue-rectangle'}
      className={classNames(classes.blueRectangleLeft1, (isIndex || haveBlueRect)
        ? classes.blueRectangleLeft1IsIndex : classes.blueRectangleLeft1IsNotIndex)}
    />
  );

  const blueRectangleLeft2 = (
    <img src={blueRectangle} alt={'blue-rectangle'} className={classes.blueRectangleLeft2} />
  );

  const rectanglePG = (
    <img src={rectanglePackGuide} alt={'rectangle-pg'} className={classes.rectanglePackGuide} />
  );

  const rectangleHIWTopRight = (
    <img src={rectanglePackGuide} alt={'rectangle-hiw'} className={classes.rectangleHiwTopRight} />
  );

  const rectangleHIWTop = (
    <img src={rectangleHiw} alt={'rectangle-hiw'} className={classes.rectangleHowItWorksTop} />
  );

  const rectangleHIWBottom = (
    <img src={rectangleHiw} alt={'rectangle-hiw'} className={classes.rectangleHowItWorksBottom} />
  );

  const rectangleHIWBottomRightTop = (
    <img src={rectangleHiw} alt={'rectangle-hiw'} className={classes.rectangleHIWBottomRightTop} />
  );

  const rectangleHIWBottomRightBottom = (
    <img
      src={rectangleHiw}
      alt={'rectangle-hiw'}
      className={classes.rectangleHIWBottomRightBottom}
    />
  );

  const rectangleHIWBottomLeft = (
    <img src={rectangleHiw} alt={'rectangle-hiw'} className={classes.rectangleHIWBottomLeft} />
  );

  const topHeader = isIndex ? mobileTopLikeIndexReal : mobileTopLikeIndex;

  const desktopTopIndex = (
    <div className={classes.phone}>
      {desktopTopIndexZigzagLines}
      <img className={classes.image} src={phoneImage} alt={'background'} />
    </div>
  );

  const desktopTopIndexLong = (
    <div className={classes.phone}>
      {desktopTopIndexZigzagLines}
      <img className={classes.image} src={phoneLongImage} alt={'background'} />
    </div>
  );

  const loadDesktopPhoneIndex = () => {
    return (
      <MediaQuery minWidth={1500}>
        {matches => (matches
          ? desktopTopIndexLong
          : desktopTopIndex)}
      </MediaQuery>
    );
  };

  return (
    <div className={classes.mainContainer}>
      <Header data={headerLinks} isIndex={isIndex} />
      <div className={footer ? classes.mainContent : null}>{children}</div>
      {footer && <Footer data={footerLinks} />}
      <MediaQuery maxWidth={800}>
        {matches => (matches
          ? (mobileLikeIndex ? topHeader : mobileTopNotIndex)
          : (isIndex ? loadDesktopPhoneIndex() : desktopTopNotIndex)
        )}
      </MediaQuery>
      {!isIndex && (<MediaQuery minWidth={800}>{desktopLeftBubble}</MediaQuery>)}
      {(!isIndex && !footer) && bottomNotIndex}
      {rectangleOne}
      {rectangleTwo}
      {blueRectangleContainer}
      {pinkRectangleContainer}
      {blueRectangleLeft1}
      {blueRectangleLeft2}
      {(isPG || isHiw) && rectanglePG}
      {isHiw && rectangleHIWTop}
      {(isPG || isHiw) && rectangleHIWBottom}
      {isHiw && rectangleHIWTopRight}
      {(isPG || isHiw) && rectangleHIWBottomRightTop}
      {(isPG || isHiw) && rectangleHIWBottomRightBottom}
      {(isPG || isHiw) && rectangleHIWBottomLeft}
      {isIndex && rectangleTwoMobile}
    </div>
  );
};

Navigation.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.any,
  footer: PropTypes.bool,
  isIndex: PropTypes.bool,
  mobileLikeIndex: PropTypes.bool,
  isPG: PropTypes.bool,
  isHiw: PropTypes.bool,
  haveBlueRect: PropTypes.bool,
};

Navigation.defaultProps = {
  children: null,
  classes: {},
  footer: true,
  isIndex: false,
  mobileLikeIndex: true,
  isPG: false,
  isHiw: false,
  haveBlueRect: false,
};

export default withStyles(styles)(Navigation);
